import { ButtonIcon } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { DocumentFile } from '@/api/documentArchive/models/DocumentFile';
import { TrackingElement, useGetTrackId } from '@/tracking';

import { useDocumentsArchiveContext } from './DocumentsArchiveContext';

interface Props {
  document: DocumentFile;
}

export const FileOperationsColumn: FC<Props> = ({ document }) => {
  const { setDocumentFileToDelete } = useDocumentsArchiveContext();
  const getTrackId = useGetTrackId();

  return (
    <Wrapper>
      <ButtonIcon
        iconName="delete"
        size="medium"
        label="Delete"
        onClick={() => setDocumentFileToDelete(document)}
        data-trackid={getTrackId('delete-file', TrackingElement.Button)}
        data-test={`delete-button-${document.id}`}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
`;
